import React from 'react'
import styled from 'styled-components'
import { queries } from '~/constants/mediaQuery'
import { Search } from 'react-feather'
import { useSearch } from '~/hooks/useSearch'
import { useIntl } from 'react-intl'

export default function SearchInput() {
  const { search, setSearch } = useSearch()
  const intl = useIntl()
  return (
    <SearchInputWrapper>
      <Search color="#8D8D8D" size={20} className="search-icon" />
      <input
        value={search}
        onChange={e => setSearch(e.target.value)}
        type="text"
        placeholder={intl.formatMessage({ id: 'Search on table' })}
      />
    </SearchInputWrapper>
  )
}

const SearchInputWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: start;
  align-items: center;

  input {
    max-width: 349px;
    width: 349px;
    border: 1px solid #d8d8d8;
    border-radius: 6px;
    padding: 0.875rem 0.875rem 0.875rem 3rem;

    &:focus-visible {
      outline: #a6a4a4 auto 2px;
    }

    @media ${queries.less.sm} {
      width: 100%;
    }
  }

  .search-icon {
    position: absolute;
    left: 1rem;
  }
`
